export enum TransactionType {
  FINANCIAL = 'FINANCIAL',
  STATISTICAL = 'STATISTICAL',
}
